import { render, staticRenderFns } from "./orderSharing.vue?vue&type=template&id=3352ddef&scoped=true&"
import script from "./orderSharing.vue?vue&type=script&lang=js&"
export * from "./orderSharing.vue?vue&type=script&lang=js&"
import style0 from "./orderSharing.vue?vue&type=style&index=0&id=3352ddef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3352ddef",
  null
  
)

export default component.exports